(function () {
  var T = window.theme || { routes: { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' }, cartType: 'drawer' };
  var drawer = function () { return document.querySelector('[data-cart-drawer]'); };

  function openCart() { var d = drawer(); if (!d) { location.href = T.routes.cart; return; } d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); }
  function closeCart() { var d = drawer(); if (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); } }

  function refreshCart(open) {
    var d = drawer();
    var countReq = fetch(T.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
    });
    if (!d) return countReq.then(function () { if (open) location.href = T.routes.cart; });
    return Promise.all([countReq, fetch(T.routes.cart + '?section_id=cart-items').then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var next = doc.querySelector('[data-cart-items]');
      var cur = d.querySelector('[data-cart-items]');
      if (next && cur) cur.replaceWith(next);
    })]).then(function () { if (open) openCart(); });
  }

  function addToCart(id, qty, btn) {
    if (btn) btn.classList.add('is-loading');
    return fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { if (btn) { btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 900); } return refreshCart(true); })
      .catch(function (e) { alert((e && (e.description || e.message)) || (T.strings && T.strings.addError) || 'Could not add to cart'); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  }

  function changeLine(line, qty) {
    var c = document.querySelector('[data-cart-items]'); if (c) c.classList.add('is-loading');
    return fetch(T.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: Number(line), quantity: Number(qty) }) })
      .then(function () { return refreshCart(false); });
  }

  // Product card carousels
  function initCard(card) {
    if (card.dataset.ready) return;
    var imgs = card.querySelectorAll('.card__img'), dots = card.querySelectorAll('.card__dot'), i = 0;
    card.dataset.ready = '1';
    function show(n) {
      if (!imgs.length) return;
      i = (n + imgs.length) % imgs.length;
      imgs.forEach(function (im, k) { im.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    show(0);
    var p = card.querySelector('[data-prev]'), n = card.querySelector('[data-next]');
    if (p) p.addEventListener('click', function (e) { e.preventDefault(); show(i - 1); });
    if (n) n.addEventListener('click', function (e) { e.preventDefault(); show(i + 1); });
    dots.forEach(function (d) { d.addEventListener('click', function () { show(Number(d.dataset.dot)); }); });
  }

  // Product page
  function initProduct(root) {
    var slides = root.querySelectorAll('.product__slide'), thumbs = root.querySelectorAll('.product__thumb');
    function showSlide(n) {
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === n); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === n); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showSlide(Number(t.dataset.thumb)); }); });

    var jsonEl = root.querySelector('[data-product-json]'); if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var idInput = root.querySelector('[data-variant-id]'), addBtn = root.querySelector('[data-add-button]');
    var addLabel = addBtn ? addBtn.textContent.trim() : 'Add to cart';
    var fieldsets = root.querySelectorAll('.product__option');
    var current = product.variants.find(function (v) { return String(v.id) === (idInput && idInput.value); }) || product.variants[0];
    var selected = current.options.slice();

    function refresh() {
      fieldsets.forEach(function (fs, idx) {
        fs.querySelectorAll('.opt').forEach(function (b) {
          var val = b.dataset.value;
          var test = selected.slice(); test[idx] = val;
          var match = product.variants.find(function (v) { return v.options.every(function (o, k) { return o === test[k]; }); });
          b.classList.toggle('is-selected', selected[idx] === val);
          b.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
      var v = product.variants.find(function (v) { return v.options.every(function (o, k) { return o === selected[k]; }); });
      if (!v) return;
      current = v;
      if (idInput) idInput.value = v.id;
      if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? addLabel : ((T.strings && T.strings.soldOut) || 'Sold out'); }
      if (v.featured_media) {
        slides.forEach(function (s, k) { if (Number(s.dataset.mediaId) === v.featured_media.id) showSlide(k); });
      }
      var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
    }
    fieldsets.forEach(function (fs, idx) {
      fs.querySelectorAll('.opt').forEach(function (b) { b.addEventListener('click', function () { selected[idx] = b.dataset.value; refresh(); }); });
    });
    if (fieldsets.length) refresh();

    var form = root.querySelector('[data-product-form]');
    if (form && T.cartType === 'drawer') form.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = form.querySelector('[name="quantity"]');
      addToCart(idInput.value, q ? Number(q.value) : 1, addBtn);
    });
  }

  function initRecommendations(el) {
    if (!el.dataset.url || el.children.length) return;
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var next = doc.querySelector('[data-recommendations]');
      if (next) { el.innerHTML = next.innerHTML; el.querySelectorAll('[data-card]').forEach(initCard); }
    });
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-card]').forEach(initCard);
    scope.querySelectorAll('[data-product]').forEach(initProduct);
    scope.querySelectorAll('[data-recommendations]').forEach(initRecommendations);
    scope.querySelectorAll('[data-sort]').forEach(function (s) {
      s.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', s.value); location.href = u; });
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var mt = t.closest('[data-menu-toggle]');
    if (mt) { var sb = document.querySelector('[data-sidebar]'); var open = !sb.classList.contains('is-open'); sb.classList.toggle('is-open', open); document.body.classList.toggle('menu-open', open); mt.setAttribute('aria-expanded', String(open)); return; }
    var open = t.closest('[data-cart-open]');
    if (open && drawer()) { e.preventDefault(); openCart(); return; }
    if (t.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); return; }
    var qa = t.closest('[data-quick-add]');
    if (qa && !qa.disabled) { e.preventDefault(); addToCart(qa.dataset.quickAdd, 1, qa); return; }
    var line = t.closest('[data-line]');
    if (line) { e.preventDefault(); changeLine(line.dataset.line, line.dataset.qty); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
  document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
